var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpuIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 18.667H5.333V5.333h13.334v13.334zm5.333-8V8h-2.667V5.333c0-1.48-1.2-2.666-2.666-2.666H16V0h-2.667v2.667h-2.666V0H8v2.667H5.333a2.657 2.657 0 00-2.666 2.666V8H0v2.667h2.667v2.666H0V16h2.667v2.667a2.667 2.667 0 002.666 2.666H8V24h2.667v-2.667h2.666V24H16v-2.667h2.667a2.667 2.667 0 002.666-2.666V16H24v-2.667h-2.667v-2.666H24zm-10.667 2.666h-2.666v-2.666h2.666v2.666zM16 8H8v8h8V8z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuIcon);
export default __webpack_public_path__ + "static/media/cpu-icon.244ea02ec112b78d3897f99798cba6b1.svg";
export { ForwardRef as ReactComponent };